import React from "react";
import EnergyGauge from "../../components/EnergyGauge";
import { usePanelData } from "../usePanelData";
import type { DataBinding, ResolvedRange } from "../spec";

interface GaugePanelProps {
  binding: DataBinding;
  range: ResolvedRange;
  /** Optional per-channel gauge range hints (min/max). */
  gaugeRange?: Record<string, { min: number; max: number }>;
}

const DEFAULT_COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#06b6d4"];

/** Renders one gauge per channel using the latest value. */
const GaugePanel: React.FC<GaugePanelProps> = ({
  binding,
  range,
  gaugeRange,
}) => {
  const { latest } = usePanelData(binding, range);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {binding.channels.map((ch, i) => {
        const value = latest.get(ch.key) ?? 0;
        const rng = gaugeRange?.[ch.key];
        return (
          <EnergyGauge
            key={ch.key}
            title={ch.label ?? ch.key}
            value={value}
            unit={ch.unit ?? ""}
            min={rng?.min}
            max={rng?.max}
            color={ch.color ?? DEFAULT_COLORS[i % DEFAULT_COLORS.length]}
          />
        );
      })}
    </div>
  );
};

export default GaugePanel;
